import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import Button from "components/Button";
import "./IndividualEnroll.scss";
// type-only (erased at compile — no runtime cycle with the parent that renders
// this view); the parent passes its full identity object through unchanged.
import type { IdentityValues } from "./IndividualEnroll";

/* eslint-disable react/no-children-prop */

interface Props {
  submitIndividual?: (identity: IdentityValues) => void;
  identity?: IdentityValues;
  onEditAddress?: () => void;
  isFetching?: boolean;
}

class IndividualVerifyInfo extends Component<Props> {
  render() {
    return (
      <div>
        <div className="individualEnroll-info-card">
          <Row>
            <Col>
              <div>
                <article className="text-cell">
                  <p className="page-eyebrow">PERSONAL INFO</p>
                  <p className="page-title">
                    Please confirm this information is correct
                  </p>
                  <p className="page-subtext">
                    We have found the following information for you through your
                    employer.
                  </p>
                </article>
              </div>

              <div className="information-section">
                <p className="info-title">Legal Name</p>
                <p className="info-subtext">
                  {this.props.identity!.firstName}{" "}
                  {this.props.identity!.lastName}
                </p>
              </div>

              <div className="information-section">
                <p className="info-title">Social Security Number</p>
                <p className="info-subtext">{this.props.identity!.ssn}</p>
              </div>

              <div className="information-section">
                <p className="info-title">Date of Birth </p>
                <p className="info-subtext">{this.props.identity!.dob}</p>
              </div>

              <div className="information-section">
                <p className="info-title">Legal Address</p>

                <p className="info-subtext">{this.props.identity!.address1}</p>

                <p className="info-subtext">
                  {this.props.identity!.city} {this.props.identity!.state}{" "}
                  {this.props.identity!.postalCode}
                </p>
              </div>

              <div className="information-section">
                <p className="info-title">Phone Number</p>

                <p className="info-subtext">{this.props.identity!.phone}</p>
              </div>
            </Col>
          </Row>
        </div>
        <div className="edit-button">
          <div className="edit">
            <Button
              type="button"
              color="cancel"
              name="action"
              btnLabel="Edit"
              onClick={() => {
                this.props.onEditAddress!();
              }}
            />
          </div>
          <Button
            name="submit"
            withArrow={true}
            loading={this.props.isFetching}
            onClick={() => {
              this.props.submitIndividual!(this.props.identity!);
            }}
          />
        </div>
      </div>
    );
  }
}

export default IndividualVerifyInfo;
